const ci = (data) => {
    return data.data.map((ci, i) => 
        <li key={i} className="py-3 list-group-item ms-2" data-aos="fade-left">{ci}</li>
    );
}
export default ci;